import React from 'react';
import styles from './InfoCard.module.scss';

const InfoCard = ({ title = '', value = '' }) => {
  return (
    <div className={styles.root}>
      <div className={styles.title}>{title}</div>
      <div className={styles.value}>{value}</div>
    </div>
  );
};

export default InfoCard;
